import React, { useRef } from 'react';
import VideoFile from '@assets/video/C2_D0_02.mp4';
import Triangulo from '@assets/images/triangulo.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './SectionFive.style';
import useVideoAutoplay from '@hooks/useVideoAutoplay'; // Importe o hook
import { useTranslation } from 'react-i18next';

const SectionFive = () => {
  const { t } = useTranslation('home');
  const videoRef = useRef(null); // Referência para o elemento de vídeo

  // Usa o hook personalizado para autoplay ao rolar
  useVideoAutoplay(videoRef, { threshold: 0.5 });

  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('sectionFive.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper className="content-wrapper">
        {/* Imagem de fundo */}
        <img
          src={Triangulo}
          alt="Imagem de fundo"
          className="background-image"
        />

        {/* Vídeo acima da imagem */}
        <video ref={videoRef} muted loop className="video">
          <source src={VideoFile} type="video/mp4" />
          Seu navegador não suporta o elemento de vídeo.
        </video>

        <TextBox1>
          <p>{t('sectionFive.paragraphOne')}</p>
          <TextBox2>
            <p>{t('sectionFive.paragraphTwo')}</p>
          </TextBox2>
        </TextBox1>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionFive;
